import { axios } from "../config/axios";
import {
  IBroadcastAudiencePreview,
  IBroadcastDetail,
  IBroadcasts,
  IBroadcastSaveRequest,
  IBroadcastUserSearchResult
} from "../interfaces/esim/BroadcastNotifications.types";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { serialize } from "../utils/serializeToQueryString";

export type getAllBroadcastsParamsType = {
  pageIndex: number;
  searchKeyword?: string;
};

export const getAllBroadcasts = async (
  att: getAllBroadcastsParamsType
): Promise<IAxiosResponse<IBroadcasts>> => {
  return axios.get<IBroadcasts>(`Notifications/Broadcasts${serialize(att)}`);
};

export const getBroadcastById = async (
  id: number
): Promise<IAxiosResponse<IBroadcastDetail>> => {
  return axios.get<IBroadcastDetail>(`Notifications/Broadcasts/${id}`);
};

export const createBroadcast = async (
  body: IBroadcastSaveRequest
): Promise<IAxiosResponse<IBroadcastDetail>> => {
  return axios.post("Notifications/Broadcasts", body);
};

export const updateBroadcast = async (
  body: IBroadcastSaveRequest,
  id: number
): Promise<IAxiosResponse<IBroadcastDetail>> => {
  return axios.put(`Notifications/Broadcasts/${id}`, body);
};

export const cancelBroadcast = async (
  id: number
): Promise<IAxiosResponse<boolean>> => {
  return axios.post(`Notifications/Broadcasts/${id}/Cancel`);
};

export type audiencePreviewParamsType = {
  platform?: string;
  languages?: string[];
  minAppVersion?: string;
  userEmails?: string[];
};

export const getBroadcastAudiencePreview = async (
  att: audiencePreviewParamsType
): Promise<IAxiosResponse<IBroadcastAudiencePreview>> => {
  // serialize() can't repeat a key for arrays, so the query is built by hand
  // (ASP.NET binds List<string> from repeated "languages" parameters).
  const parts: string[] = [];
  if (att.platform) parts.push(`platform=${encodeURIComponent(att.platform)}`);
  if (att.minAppVersion)
    parts.push(`minAppVersion=${encodeURIComponent(att.minAppVersion)}`);
  (att.languages || []).forEach((l) =>
    parts.push(`languages=${encodeURIComponent(l)}`)
  );
  (att.userEmails || []).forEach((e) =>
    parts.push(`userEmails=${encodeURIComponent(e)}`)
  );
  const query = parts.length ? `?${parts.join("&")}` : "";
  return axios.get<IBroadcastAudiencePreview>(
    `Notifications/Broadcasts/AudiencePreview${query}`
  );
};

export const searchBroadcastUsers = async (
  query: string
): Promise<IAxiosResponse<IBroadcastUserSearchResult[]>> => {
  return axios.get<IBroadcastUserSearchResult[]>(
    `Notifications/Broadcasts/SearchUsers?query=${encodeURIComponent(query)}`
  );
};

